import { Component, OnInit, Type, ViewChild } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../common/customfunctions';
import { ApiMethod } from '../apimethods/api-method';
import { Router } from '@angular/router';
import { JournalAPIModel } from './journal-model';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
declare var $;

@Component({
  selector: "app-journals",
  templateUrl: "./journals.component.html",
  styleUrls: ["./journals.component.css"]
})



/** Journals component*/
export class JournalsComponent implements OnInit {
  modelItem = new JournalAPIModel();
  @ViewChild("dataTable") table;
  years: number[] = [];
  dataTable: any;
  dataSet: any;
  status: boolean = false;
  status1: boolean = false;

  popUpButtonText: string;
  roleList: any;
  deliveryList: any;
  deliveryMethodList: any;
  journalFileTypeList: any;
  journalVendorTaskList: any;

  showContactModal: boolean;
  showDeliveryModal: boolean;
  showNotesModal: boolean;
  showBudgetModal: boolean;
  showExcelPopupBody: boolean;
  showExcelValidationPopup: boolean;
  showOnshoreModal: boolean;

  fileToUpload: File = null;
  isFileUpload: any = false;
  isFileUpdate: any = false;

  contactModalButton: string = "Submit";
  deliveryModalButton: string = "Submit";
  NotesModalButton: string = "Submit"
  BudgetModalButton: string = "Submit"
  hideExcelModalButton: string = "Upload"
  journalType: any;
  publisherID: any;
  ArticleTypeList: any;
  userList: any;
  platformList: any;
  keyFilename: any;
  aFieldList: any;
  proofingType: any;
  file: any;
  fileBase64: any;
  title: string;
  FileName: any;
  JournalNotes: any;
  Stages: any;

  styleList: any;
  PrintPublisherList: any;
  CorrXMLIDList: any;
  PreApprovalList: any;
  PageLayoutList: any;
  CEIDList: any;
  BillingList: any;
  ProjectFromList: any;
  FileLocationList: any;
  PrinterList: any;
  AllocatedUsers: any;
  LocalFilePath: any;



  ngOnInit() {
    ApiMethod.getBaseUrl();
    $('#txtTopBanner').jqte();
    $('#txtGeneralNotes').jqte();

    $('#divAddContactList').css('height', (GlobalConstants.size.height) - 200);

    $('#divJournals,#divContact,#divDelivery,#divOthers,#divNotes,#divJournalOthers,#divJournalOnshoreInfo,#divBudget')
      .css('height', (GlobalConstants.size.height) - 150);
    this.populateYears();
    $('#JournalTopBanner .jqte_editor,#JournalGeneralNotes .jqte_editor')
      .css({ 'height': (GlobalConstants.size.height - 250), 'resize': 'none' });

    $('#divStageNotesList').css('height', (GlobalConstants.size.height) - 180);

  }

  constructor(private router: Router) {

    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <JournalAPIModel>data["JournalPage"];
        this.getJournals();

        localStorage.ContactNo = 0;
        localStorage.EContactNo = 0;

        localStorage.DeliveryNo = 0;
        localStorage.EDeliveryNo = 0;

        localStorage.JournalNotes = 0;
        localStorage.EJournalNotes = 0;

        localStorage.JournalBudget = 0;
        localStorage.EJournalBudget = 0;

        localStorage.aOnshoreID = 0;

        this.hide();

        $("#lstPlatform").select2({
          placeholder: "Select Platform", dropdownParent: "#divJournals"
        });
        $("#lstPlatform").val([]).trigger("change");

        $("#journalmode").select2({
          placeholder: "Select JournalMode", dropdownParent: "#divJournals"
        });
        $("#journalmode").val([]).trigger("change");

        $("#lstRoles").select2({
          placeholder: "Select Role", dropdownParent: "#myModal"
        });
        $("#lstRoles").val([]).trigger("change");

        $('#ddlJournalType').select2({
          placeholder: "Select JournalType",
          /* allowClear: true, tags: true,*/
          dropdownParent: "#divJournals"
        });
        $('#ddlJournalType').val([]).trigger('change');

        $('#ddlProofingType').select2({
          placeholder: "Select",
          /* allowClear: true, tags: true,*/
          dropdownParent: "#divOthers"
        });
        $('#ddlProofingType').val([]).trigger('change');

        $('#ddlPublisherID').select2({
          placeholder: "Select PublisherID",
          /*  allowClear: true, tags: true,*/
          dropdownParent: "#divJournals"
        });
        $('#ddlPublisherID').val([]).trigger('change');

        $('#ddlArticleTypeList').select2({
          placeholder: "Select ArticleTypeList",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#divJournals"
        });
        $('#ddlArticleTypeList').val([]).trigger('change');

        $('#ddlStagesList').select2({
          placeholder: "Select Stages",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#divJournalOthers"
        });
        $('#ddlStagesList').val([]).trigger('change');

        $('#ddlAllocatedUsers').select2({
          placeholder: "Select",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#divJournals"
        });
        $('#ddlAllocatedUsers').val([]).trigger('change');

        $("#txtPrintPublisherID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtPrintPublisherID").val([]).trigger("change");


        $("#txtCorrXMLID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtCorrXMLID").val([]).trigger("change");


        $("#txtPreApprovalID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtPreApprovalID").val([]).trigger("change");


        $("#txtPageLayoutID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtPageLayoutID").val([]).trigger("change");


        $("#StyleId").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#StyleId").val([]).trigger("change");


        $("#txtCEID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtCEID").val([]).trigger("change");


        $("#txtBillingID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtBillingID").val([]).trigger("change");

        $("#txtProjectFromID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtProjectFromID").val([]).trigger("change");


        $("#txtFileLocationID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtFileLocationID").val([]).trigger("change");


        $("#txtPrinterID").select2({
          placeholder: "Select", dropdownParent: "#divJournalOthers"
        });
        $("#txtPrinterID").val([]).trigger("change");

        $('#ddlJournalNotes').select2({
          placeholder: "Select ",
          allowClear: true, tags: true,
          dropdownParent: "#myModalnotes"
        });
        $('#ddlJournalNotes').val([]).trigger('change');

        $('#ddlBudgetYear').select2({
          placeholder: "Select Budget Year",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#myModalbudget"
        });
        $('#ddlBudgetYear').val([]).trigger('change');

        $('#ddlVendorTask').select2({
          placeholder: "Select Task",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#myModalOnshore"
        });
        $('#ddlVendorTask').val([]).trigger('change');
        $('#ddlAllocationType').select2({
          placeholder: "Select Type",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#myModalOnshore"
        });
        $('#ddlAllocationType').val([]).trigger('change');

        this.getSetOptions();
        this.showDownload();
        this.GetJournalType();
        this.GetProofingType();
        this.GetPublisherID();
        this.GetArticleTypeList();
        this.GetStagesList();
        this.GetAlloctaedUsers();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngAfterViewChecked(): void {
    if ($('.jqte').length == 0) {
      $('#txtTopBanner').jqte();
      $('#txtGeneralNotes').jqte();
    }

  }

  populateYears() {
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;

    // Add current year if not already added
    if (!this.years.includes(currentYear)) {
      this.years.push(currentYear);
    }

    // Add next year
    this.years.push(nextYear);
  }

  //Get JournalType
  GetJournalType(): void {
    ApiMethod.getMethod(this.modelItem.JournalTypeAPI).subscribe(
      result => {
        this.journalType = result.aJournalType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get Proofing Type
  GetProofingType(): void {

    ApiMethod.getMethod(this.modelItem.ProofingTypeAPI).subscribe(
      result => {
        this.proofingType = result.aProofingSystemProofingType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get PublisherId
  GetPublisherID(): void {
    ApiMethod.getMethod(this.modelItem.PublisherIDAPI).subscribe(
      result => {
        this.publisherID = result.aPublisherID;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get ArticleTypeList
  GetArticleTypeList(): void {
    ApiMethod.getMethod(this.modelItem.ArticleTypeListAPI).subscribe(
      result => {
        this.ArticleTypeList = result.aArticleTypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get StagesList
  GetStagesList(): void {
    ApiMethod.getMethod(this.modelItem.StagesListAPI).subscribe(
      result => {
        this.Stages = result.aStagesList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get AlloctaedUsers
  GetAlloctaedUsers(): void {
    ApiMethod.getMethod(this.modelItem.AlloctaedUsersAPI).subscribe(
      result => {
        this.AllocatedUsers = result.aAllocatedUsers;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  onerrorImageLoad() {
    var zActHostpath = document.location.pathname.split('/')[1];
    $('#imgProfile').attr('src', '/' + zActHostpath + "../../../assets/Images/userLogo.jpg");
  }
  // showPreview Image Upload
  showPreview(event) {
    var ext = $('#imageUploadForm').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');

      ngswal("Failed !", "Invalid Image format", "warning");
      return false;
    }
    else if (event.target.files[0].size > 2000000) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
      ngswal("Failed !", "Please upload photo less than 2MB", "warning");
      return false;
    }
    if (event.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        $('#imgProfile').attr('src', fileReader.result);
      }
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }

  //Multiple Email Id validation
  MultipleEmail(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      if (!filter.test(email)) {
        Worngmailcount++;
        continue;
      }
      else {
        validEmails.push(email);
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
  }

  onuploadSelected(fileInput: any) {
    var ext = $('#doc_uploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf', 'zip', 'xlsx', 'xls']) == -1) {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Please upload File less than 50KB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        if (localStorage.EJournalNotes != 0) {
          this.Fileconfirmation();
        }

        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  resetFilter() {
    $("#Filterjournalmode").val("ALL").change();
    this.getJournals();
  }

  getJournals() {
    $("#LoadingImage").show();

    var journalData = {
      JournalMode: $("#Filterjournalmode").val(),
      CreatedBy: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };


    ApiMethod.postMethod(this.modelItem.JournalAPI, journalData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "btn_AddNew";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 160);
        dataItem.modulename = "JournalModule";
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable


        $("#LoadingImage").hide();


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  // Show Journal info 
  show() {
    $("#LoadingImage").show();
    $("#FilterJournal").hide();
    // $("#spAddJournalNotes").hide();
    // $("#spAddJournalNotes").prop('disabled', true);
    $("#tblAddJournalNotes").addClass("grdplace");



    this.cleareAllData();
    customfunctions.FieldConfiguration("Tbl_Journals");

    if (localStorage.aLoginID == 1)
      $("#divBanner").show();
    else
      $("#divBanner").hide();

    if (localStorage.aEID != 0) {
      var journalData = {
        Id: localStorage.aEID,
        PublisherId: localStorage.aPubID

      };
      $("#spAddJournalNotes").show();

      $("#tblAddJournalNotes").removeClass("grdplace");
      ApiMethod.postMethod(this.modelItem.JournalDetailsAPI, journalData).subscribe(
        response => {
          var details = response.journalDetails;
          let contactList = response.journalContactList;
          let deliveryList = response.journalIngestionList;
          let journalNotesList = response.journalNotes;
          let BudgetList = response.journalBudget;
          let OnshoreSetting = response.journalOnshore;

          /*Journal Info*/
          $('#txtAcronym').val(details.Acronym);
          $('#txtDoiJournalCode').val(details.DoiJournalCode);
          $('#txtJournalPublisher').val(details.JournalPublisherId);
          $('#txtTitle').val(details.JournalTitle);
          $('#txtAbbrevJournalTitle').val(details.AbbrevJournalTitle);
          $('#txtjournalFolderName').val(details.JournalFolderName);
          $('#txtTAT').val(details.TAT);
          $('#txtIssuebudgetedpages').val(details.IssueBudgetedPages);
          $('#chkManuflow').prop("checked", (details.ManflowProcess));
          $('#txtStartingYear').val(details.StartYearVolIssue);
          $('#txtStartingVolume').val(details.StartVolume);
          $('#txtStartIssueNo').val(details.StartIssueNo);
          $('#txtEndIssueNo').val(details.EndIssueNo);
          $('#journalmode').val(details.JournalMode).change();
          $("#ddlJournalType").val(details.JournalType).change();
          $("#ddlPublisherID").val(details.PublisherID).change();



          //ArticleTypeList
          if (details.ArticleTypeList != null) {

            let data = details.ArticleTypeList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlArticleTypeList').val(selectedValues).change();

          }


          if (details.IsActivate) {
            $("#rdActivate").prop("checked", true);
            $("#rdDeactivate").prop("checked", false);
          }
          else {
            $("#rdDeactivate").prop("checked", true);
            $("#rdActivate").prop("checked", false);
          }

          $("#lstPlatform").val(details.PlatformID).change();
          $("#journalmode").val(details.JournalMode).change();

          /*ISSN General Info*/
          $('#txtISSNPrint').val(details.ISSNPrint);
          $('#txtISSNWeb').val(details.ISSNWeb);
          $('#txtOnline').val(details.PrintOnline);
          $('#txtJrlContact').val(details.Contact);
          $('#txtEmailId').val(details.EmailID);
          $('#txtProjectManager').val(details.ProjectManager);
          $('#txtProjectManageremail').val(details.ProjectManagerEmail);
          $('#txtProductionManager').val(details.ProductionManager);
          $('#txtProductionManagerEmail').val(details.ProductionManagerEmail);
          $('#txtProductionEmail').val(details.ProductionEmail);
          $('#txtProductionEditor').val(details.ProductionEditor);
          $('#txtProductionEditorEmail').val(details.ProductionEditorEmail);
          $("#ddlProofingType").val(details.ProofingFlow).change();
          $('#txtProofingCCEmail').val(details.ProofingCCEmail);
          $('#txtdefectnotifyemail').val(details.DefectNotifyEmail);
          $('#txtGroupEmailId').val(details.GroupEmailId);
          $('#txtApprovalccEmail').val(details.ApprovalCCEmail);
          $('#txtWebAddress').val(details.WebAddress);
          $('#txtWebLink').val(details.WebLink);
          $('#txtcopyright').val(details.Copyright);
          $('#JournalTopBanner .jqte_editor').html(details.TopBannerLink);//Jqte editor
          $('#JournalGeneralNotes .jqte_editor').html(details.GeneralNotes);//Jqte editor





          $("#tblAddContactList tbody").html("");

          var nRowL: "";
          if (contactList.length != 0) {
            nRowL = "";
            for (var i = 0; i < contactList.length; i++) {
              nRowL += "<tr id='trCnt_" + (i + 1).toString() + "'>";
              nRowL += "<td>" + (i + 1).toString() + "</td>";
              nRowL += "<td id='cnt_" + (i + 1).toString() + "' data-id='" + contactList[i].RoleId + "' onclick='localStorage.ContactNo=" + (i + 1).toString() + "'> " + contactList[i].RoleName + "</td>";
              nRowL += "<td>" + contactList[i].ContactName + "</td>";
              nRowL += "<td>" + contactList[i].EmailId + "</td>";
              nRowL += "<td>" + contactList[i].Address + "</td>";
              nRowL += "<td style='text-align: center'>";
              nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EContactNo='" + (i + 1).toString() + "';$('#spAddContact').trigger('click');></i>&nbsp;";
              nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ContactNo='" + (i + 1).toString() + "';$('#btnDeleteContact').trigger('click');></i></td>";
              nRowL += "</tr>";
            }

            $("#tblAddContactList tbody").append(nRowL);
          }


          $("#tblAddBudgetList tbody").html("");

          var nRowL: "";

          if (BudgetList.length != 0) {
            nRowL = "";
            for (var i = 0; i < BudgetList.length; i++) {
              nRowL += "<tr id='trbudget_" + (i + 1).toString() + "'>";
              nRowL += "<td >" + (i + 1).toString() + "</td>";
              nRowL += "<td id='budgetYr_" + (i + 1).toString() + "' data-id='" + $("#ddlBudgetYear option:selected").val() + "' > " + BudgetList[i].BudgetYear + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].BudgetType) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].Article_Budget) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].Projected_Average_Page_Count) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].Per_Issue_Target) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].NonResearch_Projected_Total_Page_Count) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(BudgetList[i].Volume_Pages) + "</td>";
              nRowL += "<td style='text-align: center'>";
              nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EJournalBudget='" + (i + 1).toString() + "';$('#spAddBudget').trigger('click');></i>&nbsp;";
              nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.JournalBudget='" + (i + 1).toString() + "';$('#btnDeleteBudget').trigger('click');></i></td>";
              nRowL += "</tr>";
            }

            $("#tblAddBudgetList tbody").append(nRowL);
          }

          $("#tblAddDeliveryList tbody").html("");

          if (deliveryList.length != 0) {
            nRowL = "";
            for (var i = 0; i < deliveryList.length; i++) {
              nRowL += "<tr id='trDel_" + (i + 1).toString() + "'>";
              nRowL += "<td>" + (i + 1).toString() + "</td>";
              nRowL += "<td id='del_" + (i + 1).toString() + "' data-name='" + $("#lstDeliveries option:selected").val() + "' onclick='localStorage.DeliveryNo=" + (i + 1).toString() + "'> " + deliveryList[i].DeliveryName + "</td>";
              nRowL += "<td>" + deliveryList[i].PackageModule + "</td>";
              nRowL += "<td>" + deliveryList[i].CollectFileLocation + "</td>";
              nRowL += "<td>" + deliveryList[i].FileFormat.replaceAll("-", ",") + "</td>";
              nRowL += "<td>" + deliveryList[i].CloudMode + "</td>";

              nRowL += "<td style='display: none'>" + deliveryList[i].S3BucketName + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].Accesskey + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].Secretkey + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].RegionEndpoint + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].Remarks + "</td>";

              nRowL += "<td style='display: none'>" + deliveryList[i].SftpHost + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpUserName + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpPassword + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpPort + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].Remarks + "</td>";

              nRowL += "<td style='display: none'>" + deliveryList[i].SftpHost + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpUserName + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpPassword + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpPort + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].SftpKeyfile + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].MovePath + "</td>";
              nRowL += "<td style='display: none'>" + deliveryList[i].Remarks + "</td>";

              nRowL += "<td style='text-align: center'>";
              nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EDeliveryNo='" + (i + 1).toString() + "';$('#spAddDelivery').trigger('click');></i>&nbsp;";
              nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.DeliveryNo='" + (i + 1).toString() + "';$('#btnDeleteDelivery').trigger('click');></i></td>";
              nRowL += "</tr>";
            }

            $("#tblAddDeliveryList tbody").append(nRowL);

          }

          $("#tblAddJournalNotes tbody").html("");
          {
            if (journalNotesList.length != 0) {
              nRowL = "";
              for (var i = 0; i < journalNotesList.length; i++) {
                if (journalNotesList[i].UploadFileName != null) {
                  journalNotesList[i].UploadFileName = journalNotesList[i].UploadFileName.split('_').slice(0, -1).join('_');
                } else {
                  journalNotesList[i].UploadFileName = "_"
                }
                nRowL += "<tr id='trJnotes_" + (i + 1).toString() + "'>";
                nRowL += "<td>" + (i + 1).toString() + "</td>";
                nRowL += "<td id='Jnotes_" + (i + 1).toString() + "' data-id='" + journalNotesList[i].FileTypeId + "' onclick='localStorage.JournalNotes=" + journalNotesList[i].Id + "'> " + journalNotesList[i].FileTypeName + "</td>";
                nRowL += "<td>" + journalNotesList[i].Description + "</td>";
                nRowL += "<td onclick=localStorage.EJournalNotes='" + journalNotesList[i].Id + "';$('#btnDwnldjNotes').trigger('click'); style='cursor: pointer !important; color: #556ee6 !important; text-decoration: underline;width: auto !important;'>" + journalNotesList[i].UploadFileName + "</td>";
                nRowL += "<td style='text-align: center'>";
                nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EJournalNotes='" + journalNotesList[i].Id + "';$('#spAddJournalNotes').trigger('click');></i>&nbsp;";
                nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.JournalNotes='" + journalNotesList[i].Id + "';$('#btnDeleteJournalNotes').trigger('click');></i></td>";
                nRowL += "</tr>";
              }

              $("#tblAddJournalNotes tbody").append(nRowL);
            }
          }

          $("#tblAddOnshore tbody").html("");
          {
            if (OnshoreSetting.length != 0) {
              nRowL = "";
              for (var i = 0; i < OnshoreSetting.length; i++) {

                nRowL += "<tr id='trOnshore_" + (i + 1).toString() + "'>";
                nRowL += "<td>" + (i + 1).toString() + "</td>";
                nRowL += "<td>" + OnshoreSetting[i].TaskName + "</td>";
                nRowL += "<td>" + OnshoreSetting[i].TAT + "</td>";
                nRowL += "<td>" + OnshoreSetting[i].AllocationType + "</td>";
                nRowL += "<td>" + OnshoreSetting[i].Code + "</td>";
                nRowL += "<td>" + OnshoreSetting[i].OACode + "</td>";
                nRowL += "<td style='text-align: center'>";
                nRowL += "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.aOnshoreID='" + OnshoreSetting[i].Id + "';$('#spAddOnshore').trigger('click');></i>&nbsp;";
                nRowL += "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.aOnshoreID='" + OnshoreSetting[i].Id + "';$('#btnDeleteOnshore').trigger('click');></i></td>";
                nRowL += "</tr>";
              }

              $("#tblAddOnshore tbody").append(nRowL);
            }
          }

          //Journal Others tab
          $('#txtJournalCode').val(details.JournalCode);
          $('#txtJournalMedia').val(details.Media);
          $('#txtIssuesPerYear').val(details.IssuesPerYear);
          $("#txtPrintPublisherID").val(details.PrintPublisherID).change();
          $("#txtCorrXMLID").val(details.CorrXMLID).change();
          $("#txtPreApprovalID").val(details.PreApprovalID).change();
          $("#txtPageLayoutID").val(details.PageLayoutID).change();
          $("#StyleId").val(details.StyleID).change();
          $("#txtCEID").val(details.CEID).change();
          $("#txtBillingID").val(details.BillingID).change();
          $("#txtProjectFromID").val(details.ProjectFromID).change();
          $("#txtFileLocationID").val(details.FileLocationID).change();
          $("#txtPrinterID").val(details.PrinterID).change();
          $('#chkIsAuthorChase').prop("checked", (details.IsAuthorChase));
          $('#chkIsUploadBlock').prop("checked", (details.IsUploadBlock));
          $('#chkProofingEGAPICall').prop("checked", (details.ProofingEGAPICall));
          $('#chkSPM').prop("checked", (details.SPM));

          //StagesList
          if (details.Stages != null) {

            let data = details.Stages.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlStagesList').val(selectedValues).change();

          }


          //AlloctaedUsers
          if (details.AllocatedUsers != null) {

            let data = details.AllocatedUsers.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlAllocatedUsers').val(selectedValues).change();

          }

          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });

      this.popUpButtonText = "Update";

    }
    else {
      $("#LoadingImage").hide();

      $(".rdchkInput").prop("checked", false);

      this.popUpButtonText = "Save";
    }
    $("input.IsNumeric").keydown(e => {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) != -1 || (e.keyCode == 65 && (e.ctrlKey == true || e.metaKey == true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

    $('a[href="#divJournals"]').click();
    $("#journalsTable").hide();
    $("#journalsForm").show();
  }

  // clear journal info
  cleareAllData() {
    if (localStorage.aEID == 0) {
      $("input[type='text']").val("");
      $("input[type='number']").val("");
      $("input[type='email']").val("");
      $("input[type='radio']").prop("checked", false);
      $("input[type='checkbox']").prop("checked", false);
      $("#journalstabContent select").val(0).trigger('change');

      $('#JournalTopBanner .jqte_editor').html('');
      $('#JournalGeneralNotes .jqte_editor').html('');
      $("#txtcopyright").val("");


    }
    $("#lstPlatform").val(0).change();
    $("#journalmode").val("ALL").change();

    $("#ddlJournalType").val(0).change();
    $("#ddlProofingType").val(0).change();
    $("#ddlPublisherID").val(0).change();
    $("#ddlArticleTypeList").val(0).change();
    $("#ddlStagesList").val(0).change();
    $("#ddlAllocatedUsers").val(0).change();


    this.clearContactDeliveryData();
    $("#tblAddContactList tbody").html("");
    $("#tblAddDeliveryList tbody").html("");
    $("#tblAddJournalNotes tbody").html("");
    $("#tblAddBudgetList tbody").html("");
    $("#tblErrorValidationList tbody").html("");
  }

  hide() {
    $("#journalsTable").show();
    $("#journalsForm").hide();
    /*$("#FilterJournal").show();*/
  }

  // Add Update Journal info
  saveJournalInfo() {

    var status = false;
    if ($("input[name='status']:checked").val() == "1")
      status = true;

    var getContactList = GlobalConstants.GetTableRowToList("tblAddContactList", null);

    var getBudgetList = GlobalConstants.GetTableRowToList("tblAddBudgetList", null);

    var getDeliveryList = GlobalConstants.GetTableRowToList("tblAddDeliveryList", null);


    var isValid = this.validate(getContactList, getDeliveryList);
    if (!isValid)
      return false;

    for (var i = 0; i < getContactList.length; i++) {
      getContactList[i] = getContactList[i].toString();
    }
    for (var i = 0; i < getBudgetList.length; i++) {
      getBudgetList[i] = getBudgetList[i].toString();
    }

    for (var i = 0; i < getDeliveryList.length; i++) {
      getDeliveryList[i][4] = getDeliveryList[i][4].replaceAll(",", "-");
      getDeliveryList[i] = getDeliveryList[i].toString();
    }

    $("#LoadingImageReopen").show();


    let _generalNotes = $("#txtGeneralNotes").val().trim();
    let _topBannerJrlNotes = $("#txtTopBanner").val().trim();

    if (_generalNotes == '') {
      _generalNotes = $('#JournalGeneralNotes .jqte_editor').html().trim();
    }
    if (_topBannerJrlNotes == '') {
      _topBannerJrlNotes = $('#JournalTopBanner .jqte_editor').html().trim();
    }


    var journalData = {
      ID: localStorage.aEID,
      CreatedBy: localStorage.aLoginID,

      //Journal Details
      JournalTitle: $("#txtTitle").val(),
      Acronym: $("#txtAcronym").val(),
      DoiJournalCode: $("#txtDoiJournalCode").val(),
      JournalPublisherId: $("#txtJournalPublisher").val(),
      JournalFolderName: $("#txtjournalFolderName").val(),
      PublisherId: localStorage.aPubID,
      IsActivate: status,
      StartYearVolIssue: $("#txtStartingYear").val(),
      StartVolume: $("#txtStartingVolume").val(),
      StartIssueNo: $("#txtStartIssueNo").val(),
      EndIssueNo: $("#txtEndIssueNo").val(),
      AbbrevJournalTitle: $("#txtAbbrevJournalTitle").val(),

      TAT: $("#txtTAT").val(),
      IssueBudgetedPages: $("#txtIssuebudgetedpages").val(),

      PublisherID: $("#ddlPublisherID").val().toString(),
      JournalType: $("#ddlJournalType").val(),
      ArticleTypeList: $("#ddlArticleTypeList").val().toString(),


      //Contact Details
      ContactList: getContactList,

      //Delivery Details
      DeliveryList: getDeliveryList,

      //AnnualBudget
      AnnualBudget: getBudgetList,

      //Other Details
      PlatformId: $("#lstPlatform").val(),
      JournalMode: $("#journalmode").val().toString(),
      IssnPrint: $("#txtISSNPrint").val(),
      IssnWeb: $("#txtISSNWeb").val(),
      PrintOnline: $("#txtOnline").val(),
      Contact: $('#txtJrlContact').val(),
      EmailID: $("#txtEmailId").val(),
      ProductionEmail: $("#txtProductionEmail").val(),
      TopBannerLink: _topBannerJrlNotes,
      GeneralNotes: _generalNotes,
      ProductionEditor: $("#txtProductionEditor").val(),
      ProductionEditorEmail: $("#txtProductionEditorEmail").val(),
      ProductionManager: $("#txtProductionManager").val(),
      ProductionManagerEmail: $("#txtProductionManagerEmail").val(),
      ProjectManager: $("#txtProjectManager").val(),
      ProjectManagerEmail: $("#txtProjectManageremail").val(),
      DefectNotifyEmail: $("#txtdefectnotifyemail").val(),
      ProofingCCEmail: $("#txtProofingCCEmail").val(),
      ProofingFlow: $("#ddlProofingType").val(),
      GroupEmailId: $("#txtGroupEmailId").val(),
      ApprovalCCEmail: $("#txtApprovalccEmail").val(),
      WebAddress: $("#txtWebAddress").val(),
      WebLink: $("#txtWebLink").val(),
      Copyright: $("#txtcopyright").val(),


      //Journal Others tab info

      JournalCode: $('#txtJournalCode').val(),
      Media: $('#txtJournalMedia').val(),
      IssuesPerYear: $('#txtIssuesPerYear').val(),
      PrintPublisherID: $("#txtPrintPublisherID").val(),
      CorrXMLID: $("#txtCorrXMLID").val(),
      PreApprovalID: $("#txtPreApprovalID").val(),
      PageLayoutID: $("#txtPageLayoutID").val(),
      StyleID: $("#StyleId").val(),
      CEID: $("#txtCEID").val(),
      BillingID: $("#txtBillingID").val(),
      ProjectFromID: $("#txtProjectFromID").val(),
      FileLocationID: $("#txtFileLocationID").val(),
      PrinterID: $("#txtPrinterID").val(),
      ManflowProcess: $('#chkManuflow').prop('checked'),
      IsAuthorChase: $('#chkIsAuthorChase').prop('checked'),
      IsUploadBlock: $('#chkIsUploadBlock').prop('checked'),
      ProofingEGAPICall: $('#chkProofingEGAPICall').prop('checked'),
      SPM: $('#chkSPM').prop('checked'),
      Stages: $("#ddlStagesList").val().toString(),
      AllocatedUsers: $("#ddlAllocatedUsers").val().toString(),


    };

    ApiMethod.postMethod(this.modelItem.SaveJournalInfo, journalData).subscribe(
      result => {
        if (result.status == "success") {
          this.cleareAllData();
          this.hide();

          $("#LoadingImageReopen").hide();

          this.getJournals();

          ngswal({
            position: "top-end",
            type: "success",
            title: "Updated !",
            text: this.modelItem.SuccessMsg,
            showConfirmButton: false,
            timer: 1500
          });
        } else if (result.status == "duplicate") {
          $("#LoadingImageReopen").hide();

          ngswal("Failed !", this.modelItem.DuplicateJournalTitleErrorMsg, "warning");
        } else {
          $("#LoadingImageReopen").hide();

          ngswal("Failed !", this.modelItem.FailedMsg, "error");
        }
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.message, "error");
      });
    return false;
  }

  validate(contactList, deliveryList) {
    var aResultL = true;

    if ($("#txtTitle").val() == "") {
      $('a[href="#divJournals"]').click();
      $("#txtTitle").focus();
      ngswal("Warning !", this.modelItem.JournalTitleErrorMsg, "warning");
      aResultL = false;
    }
    else if ($("#txtAcronym").val() == "") {
      $('a[href="#divJournals"]').click();
      $("#txtAcronym").focus();
      ngswal("Warning !", this.modelItem.AcronymErrorMsg, "warning");
      aResultL = false;
    }
    else if (this.checkJournal($("#txtTitle").val())) {
      $("#txtTitle").val("");

      ngswal("Warning !", this.modelItem.DuplicateJournalTitleErrorMsg, "warning");
      aResultL = false;
    }
    else if ($("#txtDoiJournalCode").val() == "") {
      $('a[href="#divJournals"]').click();
      $("#txtDoiJournalCode").focus();
      ngswal("Warning !", this.modelItem.DoiJournalCodeErrorMsg, "warning");
      aResultL = false;
    }
    else if ($("#txtJournalPublisher").val() == "") {
      $('a[href="#divJournals"]').click();
      $("#txtJournalPublisher").focus();
      ngswal("Warning !", this.modelItem.JournalPublisherErrorMsg, "warning");
      aResultL = false;
    }
    else if ($('#txtJrlContact').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtJrlContact").focus();
      ngswal("Warning !", "Enter Journal Contact", "warning");
      aResultL = false;
    }
    else if ($('#txtEmailId').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtEmailId").focus();
      ngswal("Warning !", "Enter Journal Email", "warning");
      aResultL = false;
    }
    else if ($('#txtProjectManager').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtProjectManager").focus();
      ngswal("Warning !", "Enter Project Manager", "warning");
      aResultL = false;
    }
    else if ($('#txtProjectManageremail').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtProjectManageremail").focus();
      ngswal("Warning !", "Enter Project Manager Email", "warning");
      aResultL = false;
    }
    else if ($('#txtProductionManager').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtProductionManager").focus();
      ngswal("Warning !", "Enter Production Manager", "warning");
      aResultL = false;
    }
    else if ($('#txtProductionManagerEmail').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtProductionManagerEmail").focus();
      ngswal("Warning !", "Enter Production Manager Email", "warning");
      aResultL = false;
    }
    else if ($('#txtProductionEmail').val() == "") {
      $('a[href="#divOthers"]').click();
      $("#txtProductionEmail").focus();
      ngswal("Warning !", "Enter Production Email", "warning");
      aResultL = false;
    }
    /*else if (contactList.length == 0) {
      ngswal("Warning !", "Add Contact details !", "warning");
      aResultL = false;
    }
    else if (deliveryList.length == 0) {
      ngswal("Warning !", "Add Delivery details !", "warning");
      aResultL = false;
    }*/
    else if ($('#ddlAllocatedUsers').val() == "") {
      $('a[href="#divJournals"]').click();
      $("#ddlAllocatedUsers").focus();
      ngswal("Warning !", "Enter Allocated Users", "warning");
      aResultL = false;
    }
    else if ($('#txtTopBanner').val() == "") {
      $('a[href="#divNotes"]').click();
      $("#txtTopBanner").focus();
      ngswal("Warning !", "Enter Journal Notes", "warning");
      aResultL = false;
    }

    return aResultL;
  }

  //EmailID validation
  emailIdOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", this.modelItem.EmailFormatErrorMsg, "warning");
    }
    return true;
  }


  onSearchChange(event): void {
    this.checkJournal(event.currentTarget.value);
  }

  checkJournal(searchValue) {
    $("#LoadingImage").show();
    var journalTitleText;
    var journalAcronymText;

    if (searchValue == "")
      journalTitleText = $("#txtTitle").val(),
        journalAcronymText = $("#txtAcronym").val();
    else
      journalTitleText = searchValue;
    journalAcronymText = searchValue;

    var journalData = {
      JournalTitle: journalTitleText,
      Acronym: journalAcronymText,
      PublisherId: localStorage.aPubID,
      Id: localStorage.aEID
    };

    ApiMethod.postMethod(this.modelItem.CheckDuplicate, journalData).subscribe(
      response => {
        $("#LoadingImage").hide();

        if (response.status == "duplicate") {
          this.status = true;
          $("#txtTitle").val("");
          ngswal("Failed !", response.message, "error");
          return this.status;
        }
        else {
          this.status = false;
          return this.status;
        }
      }, error => {
        $("#LoadingImage").hide();

        ngswal("Failed !", error.error.Message, "error");
      });
    return this.status;
  }

  //dropdown list get from table
  getSetOptions() {
    $("#LoadingImage").show();

    ApiMethod.getMethod(this.modelItem.GetOptions + '/' + localStorage.aPubID).subscribe(
      response => {
        this.userList = response.journalOptions.Users;
        this.platformList = response.journalOptions.PlatForms;
        this.styleList = response.journalOptions.StyleID;
        this.PrintPublisherList = response.journalOptions.PrintPublisher;
        this.PreApprovalList = response.journalOptions.PreApproval;
        this.PageLayoutList = response.journalOptions.PageLayout;
        this.CorrXMLIDList = response.journalOptions.CorrectionXML;
        this.CEIDList = response.journalOptions.CE_Edit;
        this.BillingList = response.journalOptions.BillingTypes;
        this.FileLocationList = response.journalOptions.FileLocation;
        this.ProjectFromList = response.journalOptions.ProjectFrom;
        this.PrinterList = response.journalOptions.Printer;
        this.roleList = response.journalOptions.JournalRoles;
        this.deliveryList = response.journalOptions.JournalDeliveries;
        this.journalFileTypeList = response.journalOptions.JournalFileTypeList;
        this.journalVendorTaskList = response.journalOptions.JournalVendorTaskList;
        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //show contact Journal info
  showContact() {
    this.showContactModal = true;

    if (localStorage.EContactNo != "0") {
      let trId = "#trCnt_" + localStorage.EContactNo;
      $("#txtContact").val($(trId).find("td")[2].outerText);
      $("#txtEmail").val($(trId).find("td")[3].outerText);
      $("#txtAddress").val($(trId).find("td")[4].outerText);

      $("#lstRoles").val($($(trId).find("td")[1]).attr("data-id")).change();

      this.contactModalButton = "Update";
    }
    else {
      this.contactModalButton = "Add";

      this.clearContactDeliveryData();
    }
  }

  addUpdateContact() {
    //EContactNo
    var isValid = this.contactValidation();

    if (!isValid)
      return false;

    let zchkVal: boolean = true;
    //if ($("#tblAddContactList tbody").length == 0) {
    //  $("#tblAddContactList").append("<tbody></tbody>");
    //}
    var zRowLength = $("#tblAddContactList").find("tr").length;
    if (zRowLength >= 1) {
      var isExist = 0;
      $.each($("#tblAddContactList tbody tr"), function () {
        var zpreEmail = $(this).find("td")[3].outerText;
        var zpreId = $(this).find("td")[0].outerText;

        var zpreRole = $(this).find("td")[1].outerText;
        var dlrolel = $("#lstRoles option:selected").text();

        var dlemail = $("#txtEmail").val();

        if ((localStorage.EContactNo.toString() != zpreId.toString || localStorage.EContactNo == 0) && zpreEmail.trim() == dlemail.trim() && zpreRole.trim() == dlrolel.trim()) {
          ngswal("Failed !", "Already Email added", "warning");
          isExist = 1;

          return false;
        }

      });

      if (isExist == 1) {

        return false;

      }
      if (localStorage.EContactNo != 0) {
        zchkVal = false;
        $("#spUpdateContact").trigger("click");
      }
    }

    if (zchkVal) {

      $("#tblAddContactList tbody").append(
        "<tr id='trCnt_" + zRowLength.toString() + "'>" +
        "<td>" + zRowLength.toString() + "</td>" +
        "<td id='cnt_" + zRowLength.toString() + "' data-id='" + $("#lstRoles option:selected").val() + "' onclick='localStorage.ContactNo=" + zRowLength.toString() + "'> " + $("#lstRoles option:selected").text() + "</td>" +
        "<td>" + $("#txtContact").val() + "</td>" +
        "<td>" + $("#txtEmail").val() + "</td>" +
        "<td>" + $("#txtAddress").val() + "</td>" +
        "<td style='text-align: center'>"
        + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EContactNo='" + zRowLength.toString() + "';$('#spAddContact').trigger('click');></i>&nbsp;"
        + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ContactNo='" + zRowLength.toString() + "';$('#btnDeleteContact').trigger('click');></i></td>" +
        "</tr>"
      );

      this.hideContact();
    }
    return false;
  }

  contactValidation() {
    var result = true;
    if ($("#lstRoles").val() == null) {
      $('a[href="#divContact"]').click();
      $("#lstRoles").focus();
      ngswal("Warning !", "Select Journal Role!", "warning");
      result = false;
    }
    else if ($("#txtContact").val() == "") {
      $('a[href="#txtContact"]').click();
      $("#lstRoles").focus();
      ngswal("Warning !", "Enter Contact Name!", "warning");
      result = false;
    }
    else if ($("#txtEmail").val() == "") {
      $('a[href="#txtContact"]').click();
      $("#txtEmail").focus();
      ngswal("Warning !", "Enter Email Id!", "warning");
      result = false;
    }
    //else if ($("#txtAddress").val() == "") {
    //  ngswal("Warning !", "Enter Address!", "warning");
    //  result = false;
    //}
    return result;
  }

  updateContactData() {
    let trId = "#trCnt_" + localStorage.EContactNo;
    $(trId).find("td")[1].outerHTML = "<td id='cnt_" + localStorage.EContactNo.toString() + "' data-id='" + $("#lstRoles option:selected").val() + "' onclick='localStorage.ContactNo=" + localStorage.EContactNo.toString() + "'>" + $("#lstRoles option:selected").text() + "</td>";
    $(trId).find("td")[2].outerHTML = "<td>" + $("#txtContact").val() + "</td>";
    $(trId).find("td")[3].outerHTML = "<td>" + $("#txtEmail").val() + "</td>";
    $(trId).find("td")[4].outerHTML = "<td>" + $("#txtAddress").val() + "</td>";
    this.hideContact();
  }

  deleteContact() {
    $("#cnt_" + localStorage.ContactNo).closest("tr").remove();

    $("table#tblAddContactList tbody").each(function () {
      $(this).children().each(function (index) {
        $(this).find("td").first().html((index + 1).toString());
      });
    });
  }

  hideContact() {
    this.showContactModal = false;
    this.clearContactDeliveryData();
    localStorage.EContactNo = 0;
    localStorage.ContactNo = 0;
  }

  // Show Budget Journal Info

  showBudget() {
    this.showBudgetModal = true;
    let nextYear = new Date().getFullYear();
    this.years.push(nextYear);
    if (localStorage.EJournalBudget != "0") {
      this.years = [];
      let trId = "#trbudget_" + localStorage.EJournalBudget;
      this.years.push($(trId).find("td")[1].innerText);

      $("#ddlBudgetYear").prop('disabled', true).val($(trId).find("td")[1].innerText).change();
      $("#txtBudgetType").val($(trId).find("td")[2].innerText);
      $("#txtArticleBudget").val($(trId).find("td")[3].innerText);
      $("#txtArticlepagecount").val($(trId).find("td")[4].innerText);
      $("#txtPerIssueTarget").val($(trId).find("td")[5].innerText);
      $("#txtProjectedtotalpagecount").val($(trId).find("td")[6].innerText);
      $("#txtVolumePages").val($(trId).find("td")[7].innerText);
      this.BudgetModalButton = "Update";
    }
    else {

      this.years = [];

      var tblBudgetyear = "";

      var zRowLength = $("#tblAddBudgetList tbody").find("tr").length;
      if (zRowLength >= 1) {
        tblBudgetyear = $("#tblAddBudgetList tbody tr").last().find("td:eq(1)").text();
        var ackeck = new Date().getFullYear();
        ackeck = ackeck + 2;
        nextYear = parseInt(tblBudgetyear, 10);
        if (!isNaN(nextYear)) {
          nextYear++;
          if (ackeck == nextYear) {
            this.showBudgetModal = false;
            ngswal("Warning !", "Current Year and Next Year only Allowed.!", "warning");
          }
        } else {
          console.error('Invalid year format:', tblBudgetyear);
        }
        this.years.push(nextYear);

      } else {
        let nextYear = new Date().getFullYear();
        this.years.push(nextYear);
      }
      this.BudgetModalButton = "Add";
      $("#ddlBudgetYear").prop('disabled', false);
      this.clearBudgetdata();
    }
  }

  addUpdateBudget() {

    if ($('#ddlBudgetYear').val() == null) {
      ngswal("Warning !", "Enter Budget Year!", "warning");
    }
    else if ($('#txtBudgetType').val() == '') {
      ngswal("Warning !", "Enter Budget Type!", "warning");
    }
    else if ($('#txtArticleBudget').val() == '') {
      ngswal("Warning !", "Enter Article Budget!", "warning");
    }
    else if ($('#txtArticlepagecount').val() == '') {
      ngswal("Warning !", "Enter Projected Average page count!", "warning");
    }
    else if ($('#txtPerIssueTarget').val() == '') {
      ngswal("Warning !", "Enter Per Issue Target!", "warning");
    }
    else if ($('#txtProjectedtotalpagecount').val() == '') {
      ngswal("Warning !", "Enter Projected total page Count!", "warning");
    }
    else if ($('#txtVolumePages').val() == '') {
      ngswal("Warning !", "Enter Volume Pages!", "warning");
    }
    else {
      //$("#LoadingImagePopup").show();


      if (localStorage.EJournalBudget == 0) {
        var zRowLength = $("#tblAddBudgetList").find("tr").length;
        $("#tblAddBudgetList tbody").append(
          "<tr id='trbudget_" + zRowLength.toString() + "'>" +
          "<td>" + zRowLength.toString() + "</td>" +
          "<td >" + $("#ddlBudgetYear").val() + "</td>" +
          "<td >" + $("#txtBudgetType").val() + "</td>" +
          "<td >" + $("#txtArticleBudget").val() + "</td>" +
          "<td >" + $("#txtArticlepagecount").val() + "</td>" +
          "<td >" + $("#txtPerIssueTarget").val() + "</td>" +
          "<td >" + $("#txtProjectedtotalpagecount").val() + "</td>" +
          "<td >" + $("#txtVolumePages").val() + "</td>" +
          "<td style='text-align: center'>"
          + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EJournalBudget='" + zRowLength.toString() + "';$('#spAddBudget').trigger('click');></i>&nbsp;"
          + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.JournalBudget='" + zRowLength.toString() + "';$('#btnDeleteBudget').trigger('click');></i></td>" +
          "</tr>"
        );
        this.hideBudget();


      } else {
        let trId = "#trbudget_" + localStorage.EJournalBudget;
        $(trId).find("td")[1].outerHTML = "<td>" + $("#ddlBudgetYear").val() + "</td>";
        $(trId).find("td")[2].outerHTML = "<td>" + $("#txtBudgetType").val() + "</td>";
        $(trId).find("td")[3].outerHTML = "<td>" + $("#txtArticleBudget").val() + "</td>";
        $(trId).find("td")[4].outerHTML = "<td>" + $("#txtArticlepagecount").val() + "</td>";
        $(trId).find("td")[5].outerHTML = "<td>" + $("#txtPerIssueTarget").val() + "</td>";
        $(trId).find("td")[6].outerHTML = "<td>" + $("#txtProjectedtotalpagecount").val() + "</td>";
        $(trId).find("td")[7].outerHTML = "<td>" + $("#txtVolumePages").val() + "</td>";

        this.hideBudget();
      }
    }
  }

  deleteBudget() {
    $("#trbudget_" + localStorage.JournalBudget).closest("tr").remove();

    $("table#tblAddBudgetList tbody").each(function () {
      $(this).children().each(function (index) {
        $(this).find("td").first().html((index + 1).toString());
      });
    });
  }

  hideBudget() {
    this.showBudgetModal = false;
    this.clearBudgetdata();
    localStorage.JournalBudget = 0;
    localStorage.EJournalBudget = 0;
  }

  // clear Budget data
  clearBudgetdata() {
    $("#myModalbudget input[type='text']").val("");
    $("#myModalbudget input[type='number']").val("");
    $("#ExcelPopupBody input[type='file']").val("");
    $("#ddlBudgetYear").val(0).change();
  }



  //show delivery journal info
  showDelivery() {
    this.showDeliveryModal = true;

    if (localStorage.EDeliveryNo != "0") {
      let trId = "#trDel_" + localStorage.EDeliveryNo;

      $("#lstDeliveries").val($(trId).find("td")[1].outerText).change();
      $("#ddlDeliveryMethod").val($(trId).find("td")[2].outerText).change();
      $("#txtFileLocation").val($(trId).find("td")[3].outerText);
      $("#txtFileFormat").val($(trId).find("td")[4].outerText);

      if ($(trId).find("td")[5].outerText == "S3") {
        $("#ddlFileLocation").val("S3").change();
        $("#DS3").show();
        $("#DSFTP").hide();
        $("#DFTP").hide();

        $("#txtBucketName").val($(trId).find("td")[6].outerText);
        $("#txtAccessKey").val($(trId).find("td")[7].outerText);
        $("#txtSecurityKey").val($(trId).find("td")[8].outerText);
        $("#txtEndpointregion").val($(trId).find("td")[9].outerText);
        $("#txtRemarks").val($(trId).find("td")[10].outerText);
      } else if ($(trId).find("td")[5].outerText == "FTP") {
        $("#ddlFileLocation").val("FTP").change();
        $("#DS3").hide();
        $("#DSFTP").hide();
        $("#DFTP").show();

        $("#txtFHost").val($(trId).find("td")[11].outerText);
        $("#txtFUserName").val($(trId).find("td")[12].outerText);
        $("#txtFPassword").val($(trId).find("td")[13].outerText);
        $("#txtFPort").val($(trId).find("td")[14].outerText);
        $("#txtFRemarks").val($(trId).find("td")[15].outerText);
      } else if ($(trId).find("td")[5].outerText == "SFTP") {
        $("#ddlFileLocation").val("SFTP").change();
        $("#DS3").hide();
        $("#DSFTP").show();
        $("#DFTP").hide();

        $("#txtSFHost").val($(trId).find("td")[16].outerText);
        $("#txtSFUserName").val($(trId).find("td")[17].outerText);
        $("#txtSFPassword").val($(trId).find("td")[18].outerText);
        $("#txtSFPort").val($(trId).find("td")[19].outerText);
        this.keyFilename = $(trId).find("td")[20].outerText;
        this.isFileUpload = true;
        $("#txtSFFolderPath").val($(trId).find("td")[21].outerText);
        $("#txtSFRemarks").val($(trId).find("td")[22].outerText);
      }

      this.deliveryModalButton = "Update";
    }
    else {
      this.deliveryModalButton = "Add";

      this.clearContactDeliveryData();
    }
  }

  addUpdateDelivery() {
    var isValid = this.deliveryValidation();
    if (!isValid)
      return false;

    let zchkVal: boolean = true;
    if ($("#tblAddDeliveryList tbody").length == 0) {
      $("#tblAddDeliveryList").append("<tbody></tbody>");
    }
    var zRowLength = $("#tblAddDeliveryList").find("tr").length;
    if (zRowLength >= 1) {
      $.each($("#tblAddDeliveryList tbody tr"), function () {

        var zpreVal = $(this).find("td")[1].outerText;
        var dlVal = $("#lstDeliveries option:selected").val();
        if (zpreVal == dlVal) {
          if (localStorage.EDeliveryNo != "0") {
            $("#spUpdateDelivery").trigger("click");
          }
          else {
            ngswal("Failed !", "Already Delivery added", "warning");
          }
          zchkVal = false;
        }
      });
    }

    if (zchkVal) {
      var keyFileName = "";
      if (this.fileToUpload != null)
        keyFileName = this.fileToUpload.name;

      $("#tblAddDeliveryList tbody").append(
        "<tr id='trDel_" + zRowLength.toString() + "'>" +
        "<td>" + zRowLength.toString() + "</td>" +
        "<td id='del_" + zRowLength.toString() + "' data-name='" + $("#lstDeliveries option:selected").val() + "' onclick='localStorage.DeliveryNo=" + zRowLength.toString() + "'> " + $("#lstDeliveries option:selected").text() + "</td>" +
        "<td>" + $("#ddlDeliveryMethod option:selected").val().trim() + "</td>" +
        "<td>" + $("#txtFileLocation").val() + "</td>" +
        "<td>" + $("#txtFileFormat").val() + "</td>" +
        "<td>" + $("#ddlFileLocation option:selected").val().trim() + "</td>" +

        "<td style='display: none'>" + $("#txtBucketName").val() + "</td>" +
        "<td style='display: none'>" + $("#txtAccessKey").val() + "</td>" +
        "<td style='display: none'>" + $("#txtSecurityKey").val() + "</td>" +
        "<td style='display: none'>" + $("#txtEndpointregion").val() + "</td>" +
        "<td style='display: none'>" + $("#txtRemarks").val() + "</td>" +

        "<td style='display: none'>" + $("#txtFHost").val() + "</td>" +
        "<td style='display: none'>" + $("#txtFUserName").val() + "</td>" +
        "<td style='display: none'>" + $("#txtFPassword").val() + "</td>" +
        "<td style='display: none'>" + $("#txtFPort").val() + "</td>" +
        "<td style='display: none'>" + $("#txtFRemarks").val() + "</td>" +

        "<td style='display: none'>" + $("#txtSFHost").val() + "</td>" +
        "<td style='display: none'>" + $("#txtSFUserName").val() + "</td>" +
        "<td style='display: none'>" + $("#txtSFPassword").val() + "</td>" +
        "<td style='display: none'>" + $("#txtSFPort").val() + "</td>" +
        "<td style='display: none'>" + keyFileName + "</td>" +
        "<td style='display: none'>" + $("#txtSFFolderPath").val() + "</td>" +
        "<td style='display: none'>" + $("#txtSFRemarks").val() + "</td>" +

        "<td style='text-align: center'>"
        + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EDeliveryNo='" + zRowLength.toString() + "';$('#spAddDelivery').trigger('click');></i>&nbsp;"
        + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.DeliveryNo='" + zRowLength.toString() + "';$('#btnDeleteDelivery').trigger('click');></i></td>" +
        "</tr>"
      );

      this.clearContactDeliveryData();
    }
    return false;
  }

  deliveryValidation() {
    var result = true;

    if ($("#lstDeliveries").val() == null) {
      ngswal("Warning !", "Select Delivery Name!", "warning");
      result = false;
    }
    else if ($("#ddlDeliveryMethod").val() == null) {
      ngswal("Warning !", "Select Delivery Type!", "warning");
      result = false;
    }
    else if ($("#ddlFileLocation").val() == null) {
      ngswal("Warning !", "Select File Location!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "S3") && $("#txtBucketName").val() == "") {
      ngswal("Warning !", "Enter Bucket Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "S3") && $("#txtAccessKey") == "") {
      ngswal("Warning !", "Enter Access Key!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "S3") && $("#txtSecurityKey") == "") {
      ngswal("Warning !", "Enter Security Key!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "FTP") && $("#txtFHost").val() == "") {
      ngswal("Warning !", "Enter Host Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "FTP") && $("#txtFPort").val() == "") {
      ngswal("Warning !", "Enter Port Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "FTP") && $("#txtFUserName").val() == "") {
      ngswal("Warning !", "Enter User Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "FTP") && $("#txtFPassword").val() == "") {
      ngswal("Warning !", "Enter Password!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "SFTP") && $("#txtSFHost").val() == "") {
      ngswal("Warning !", "Enter Host Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "SFTP") && $("#txtSFPort").val() == "") {
      ngswal("Warning !", "Enter Port Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "SFTP") && $("#txtSFUserName").val() == "") {
      ngswal("Warning !", "Enter User Name!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "SFTP") && $("#txtSFPassword").val() == "") {
      ngswal("Warning !", "Enter Password!", "warning");
      result = false;
    }
    else if (($("#ddlFileLocation").val() == "SFTP") && this.isFileUpload == false) {
      ngswal("Warning !", "Upload File!", "warning");
      result = false;
    }

    return result;
  }

  updateDeliveryData() {
    let trId = "#trDel_" + localStorage.EDeliveryNo;
    var fileName = "";
    if (this.fileToUpload == null)
      fileName = this.keyFilename;
    else {
      if (this.isFileUpdate)
        fileName = this.fileToUpload.name;
    }

    $(trId).find("td")[1].outerHTML = "<td id='del_" + localStorage.EDeliveryNo.toString() + "' data-name='" + $("#lstDeliveries option:selected").val() + "' onclick='localStorage.DeliveryNo=" + localStorage.EDeliveryNo.toString() + "'>"
      + $("#lstDeliveries option:selected").text() + "</td>";
    $(trId).find("td")[2].outerHTML = "<td>" + $("#ddlDeliveryMethod option:selected").val().trim() + "</td>";
    $(trId).find("td")[3].outerHTML = "<td>" + $("#txtFileLocation").val() + "</td>";
    $(trId).find("td")[4].outerHTML = "<td>" + $("#txtFileFormat").val() + "</td>";
    $(trId).find("td")[5].outerHTML = "<td>" + $("#ddlFileLocation option:selected").val().trim() + "</td>";

    $(trId).find("td")[6].outerHTML = "<td style='display:none'>" + $("#txtBucketName").val() + "</td>";
    $(trId).find("td")[7].outerHTML = "<td style='display:none'>" + $("#txtAccessKey").val() + "</td>";
    $(trId).find("td")[8].outerHTML = "<td style='display:none'>" + $("#txtSecurityKey").val() + "</td>";
    $(trId).find("td")[9].outerHTML = "<td style='display:none'>" + $("#txtEndpointregion").val() + "</td>";
    $(trId).find("td")[10].outerHTML = "<td style='display:none'>" + $("#txtRemarks").val() + "</td>";

    $(trId).find("td")[11].outerHTML = "<td style='display:none'>" + $("#txtFHost").val() + "</td>";
    $(trId).find("td")[12].outerHTML = "<td style='display:none'>" + $("#txtFUserName").val() + "</td>";
    $(trId).find("td")[13].outerHTML = "<td style='display:none'>" + $("#txtFPassword").val() + "</td>";
    $(trId).find("td")[14].outerHTML = "<td style='display:none'>" + $("#txtFPort").val() + "</td>";
    $(trId).find("td")[15].outerHTML = "<td style='display:none'>" + $("#txtFRemarks").val() + "</td>";

    $(trId).find("td")[16].outerHTML = "<td style='display:none'>" + $("#txtSFHost").val() + "</td>";
    $(trId).find("td")[17].outerHTML = "<td style='display:none'>" + $("#txtSFUserName").val() + "</td>";
    $(trId).find("td")[18].outerHTML = "<td style='display:none'>" + $("#txtSFPassword").val() + "</td>";
    $(trId).find("td")[19].outerHTML = "<td style='display:none'>" + $("#txtSFPort").val() + "</td>";
    $(trId).find("td")[20].outerHTML = "<td style='display:none'>" + fileName + "</td>";
    $(trId).find("td")[21].outerHTML = "<td style='display:none'>" + $("#txtSFFolderPath").val() + "</td>";
    $(trId).find("td")[22].outerHTML = "<td style='display:none'>" + $("#txtSFRemarks").val() + "</td>";

    this.hideDelivery();
  }

  deleteDelivery() {
    $("#del_" + localStorage.DeliveryNo).closest("tr").remove();

    $("table#tblAddDeliveryList tbody").each(function () {
      $(this).children().each(function (index) {
        $(this).find("td").first().html((index + 1).toString());
      });
    });
  }

  hideDelivery() {
    this.showDeliveryModal = false;
    this.clearContactDeliveryData();
    localStorage.EDeliveryNo = 0;
    localStorage.DeliveryNo = 0;
  }


  //show journal notes info
  showJournalNotes() {

    this.showNotesModal = true;
    this.clearJournalNotes();
    this.fileBase64 = null;
    this.file = null;
    $('#container').hide();
    if (localStorage.EJournalNotes != 0) {
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.ShowJournalNotesByID + '/' + localStorage.EJournalNotes).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;

          $('#JournalNotesDescription').val(aitems[0].Description);
          $("#ddlJournalNotes").val(aitems[0].FileTypeName).change();
          this.FileName = aitems[0].UploadFileName.split('_').slice(0, -1).join('_');

          if (aitems[0].UploadFileName != null) {
            $(".UploadFile").show();
            $('#btndownloadJournalNotes').show();
          }
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.NotesModalButton = "Update";
    } else {
      this.NotesModalButton = "Save";
      this.title = "Update Notes";
      $(".btnRemovefile").hide();
    }
  }

  addUpdateNotes() {
    if
      ($('#JournalNotesDescription').val() == '') {
      ngswal("Warning !", "Enter Description  !", "warning");
    }
    else if ($('#ddlJournalNotes').val() == null) {
      ngswal("Warning !", "Select Type!", "warning");
    }

    else {
      //$("#LoadingImagenotes").show();
      let fileName = null; let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size
      }
      var JournalNotes = {
        Journalnotes: $('#txtTopBanner').val(),
        Description: $('#JournalNotesDescription').val(),
        FileTypeName: $('#ddlJournalNotes').val(),
        fileName: fileName,
        fileSize: fileSize,
        fileAsBase64: this.fileBase64,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        JournalId: localStorage.aEID,
        Id: localStorage.EJournalNotes
      };

      ApiMethod.postMethod(this.modelItem.JournalNotesByIDAPI, JournalNotes).subscribe(
        result => {
          this.showNotesModal = false;
          if (result.status == 'Success') {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Updated !",
              text: result.message,
              showConfirmButton: true,
            });
            this.hide();
            this.getSetOptions();
          }
          $("#LoadingImagenotes").hide();
        }, error => {
          ngswal("Failed!", error.Message, "error");
          $("#LoadingImagenotes").hide();
        }
      );

    }
  }

  // file confirmation for new File upload 
  Fileconfirmation() {

    ngswal({
      title: "File Upload",
      text: "Are you sure want to Upload new File?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {

          return false;

        } else {
          $("#doc_uploadfile").val("");
          this.fileBase64 = null;
          this.fileName = null;
          this.fileSize = null;
          return false;
        }
      });
  };

  DownloadJournalNotes() {
    $("#LoadingImageReopen").show();
    var aEid = localStorage.EJournalNotes;
    ApiMethod.Downloadfile(this.modelItem.JournalNotesDownloadFilesAPI + "/" + aEid);
    $("#LoadingImageReopen").hide()
  }

  deleteJournalNotes() {
    $("#LoadingImagePopup").show();
    ApiMethod.getMethod(this.modelItem.DeleteJournalNotesByID + "/" + localStorage.JournalNotes).subscribe(
      Response => {
        this.hide();
        this.getJournals();
        if (Response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: Response.message,
            showConfirmButton: true,
          });
        } else {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Failed !",
            text: Response.message,
            showConfirmButton: true,
          });
        }

        $("#LoadingImagePopup").hide();
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }

  // file delete confirmation from AWS 
  Deleteconfirmation() {
    ngswal({
      title: "Are You Confirm to delete Journal Notes?",
      text: "Journal Notes deleted Permanently..!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnDeleteJournalNote').trigger("click");
        } else {
          return false;
        }
      });
  };

  hideNotes() {
    this.showNotesModal = false;
    this.clearJournalNotes();
    localStorage.EJournalNotes = 0;
    localStorage.JournalNotes = 0;
  }

  clearJournalNotes() {
    $("#ddlJournalNotes").val(0).change();
    $("#JournalNotesDescription").val("");
    $("#doc_uploadfile").val("");
    $(".UploadFile").show();
    $(".btnRemovefile").hide();
    $('#btndownloadJournalNotes').hide();
  }

  /* Journal notes End*/


  updateUi(): void {
    this.showDownload();
  }

  showDownload(): void {
    if ($("#ddlFileLocation").val() == "S3") {
      $("#DS3").show();
      $("#DSFTP").hide();
      $("#DFTP").hide();
    }
    else if ($("#ddlFileLocation").val() == "FTP") {
      $("#DFTP").show();
      $("#DS3").hide();
      $("#DSFTP").hide();
    }
    else if ($("#ddlFileLocation").val() == "SFTP") {
      $("#DSFTP").show();
      $("#DFTP").hide();
      $("#DS3").hide();
    }
  }

  getDeliveryMethods() {
    var deliveryName = "";
    $("#LoadingImagePopup").show();

    if ($("#lstDeliveries option:selected").val() != undefined || $("#lstDeliveries option:selected").val() != null)
      deliveryName = $("#lstDeliveries option:selected").val();

    ApiMethod.getMethod(this.modelItem.JournalDeliveryMethodList + '/' + deliveryName).subscribe(
      result => {
        this.deliveryMethodList = result.deliveryMethodList;
        $("#LoadingImagePopup").hide();

      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  // clear contact delivery data
  clearContactDeliveryData() {
    $("#lstRoles").val(0).change();
    $("#txtContact").val("");
    $("#txtEmail").val("");
    $("#txtAddress").val("");


    $("#lstDeliveries").val(0).change();
    $("#ddlDeliveryMethod").val(0).change();

    $("#ddlFileLocation").val(1).change();

    $("#txtFileLocation").val("");
    $("#txtFileFormat").val("");

    $("#ddlFileLocation").val("S3").change();
    this.showDownload();

    //S3
    $("#txtBucketName").val("");
    $("#txtAccessKey").val("");
    $("#txtSecurityKey").val("");
    $("#txtEndpointregion").val("");
    $("#txtRemarks").val("");

    //FTP
    $("#txtFHost").val("");
    $("#txtFUserName").val("");
    $("#txtFPassword").val("");
    $("#txtFPort").val("");
    $("#txtFRemarks").val("");

    //SFTP
    $("#txtSFHost").val("");
    $("#txtSFUserName").val("");
    $("#txtSFPassword").val("");
    $("#txtSFPort").val("");
    $("#txtSFFolderPath").val("");
    $("#SFfile-input").val("");
    $("#txtSFRemarks").val("");

    this.fileToUpload = null;
    this.keyFilename = null;
  }

  selectUploadFile = (files) => {
    if (files.length == 0) {
      return false;
    }

    let ext = <File>files[0].name.toString().split(".").pop().toLowerCase();
    if ($.inArray(ext, ["ppk", "pem"]) == -1) {
      ngswal("Warning !", "Invalid Package format !", "warning");
      this.fileToUpload = null;
      return false;
    }

    this.fileToUpload = <File>files[0];
    return true;
  }

  submitFile() {
    var journalTitle = $("#txtTitle").val();

    if (journalTitle == "") {
      ngswal("Warning !", this.modelItem.JournalTitleErrorMsg, "warning");
      this.keyFilename = null;
      this.isFileUpload = false;
      this.isFileUpdate = false;
      return false;
    }

    if (($("#ddlFileLocation").val() == "SFTP") && this.fileToUpload == null) {
      ngswal("Warning !", "Select File!", "warning");
      this.isFileUpload = false;
    } else {
      $("#LoadingImagePopup").show();

      const formData = new FormData();

      formData.append("file", this.fileToUpload, this.fileToUpload.name);
      formData.append("ClientApiUrl", this.modelItem.JournalUploadKeyFile);
      formData.append("remarks", journalTitle);

      let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));

      http.post($("base")[0].href + "api/Endpoint/PostFileClient", formData).subscribe(
        (response: Response) => {
          let msgInfo = "Success"; let msgDetails = "";
          let result = $(response.headers);

          $.each(result, (e, val) => {
            if (val.key == "ErrorMessage") {
              msgInfo = "Warning";
              msgDetails = val.value.toString();
              this.isFileUpload = false;
              this.isFileUpdate = false;
            }
            else if (val.key == "SuccessMessage") {
              msgInfo = "Success";
              msgDetails = val.value.toString();
              this.isFileUpload = true;
              this.isFileUpdate = true;
              this.keyFilename = this.fileToUpload.name;
            }
          });

          ngswal({
            position: "top-end",
            type: msgInfo.toLowerCase(),
            title: "<i>" + msgInfo + "</i>",
            text: msgDetails,
            showConfirmButton: false,
            timer: 1500,
            html: true
          });

          $("#LoadingImagePopup").hide();
        },
        (error) => {
          ngswal("Warning !", error.message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
    return false;
  }

  downloadkeyfile() {
    var deliveryName = $("#lstDeliveries option:selected").val();
    var journalTitle = $("#txtTitle").val();
    let apiurl = this.modelItem.JournalDownloadKeyFile;

    ApiMethod.Downloadfile(apiurl + localStorage.aEID + "/" + deliveryName + "/" + journalTitle);
  }

  // Import Excel bgimp
  onImportSelected(fileInput: any) {

    var ext = $('#doc_file').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['xlsx']) == -1) {
      $('#doc_file').val("");
      ngswal("Failed !", "Invalid File format \n Please Refer Sample File", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);

      }
      this.Importconfirmation()
    }
  }

  Importconfirmation() {
    if ($('#doc_file').val() == "") {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    ngswal({
      title: "File Upload Confirmation",
      text: this.file.name + "\nAre you sure Submit File?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnvalidationerror').trigger("click");
          this.file = "";
          this.fileBase64 = null;
        } else {
          $('#doc_file').val("");
          return false;

        }
      });
  };

  addUpdateImportExcel() {
    $("#LoadingImage").show();
    var filedetails = {
      ID: localStorage.aEID,
      UserName: localStorage.aLoginName,
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,
    }

    ApiMethod.postMethod(this.modelItem.ValidateImportExcelFile, filedetails).subscribe(
      response => {
        $("#LoadingImage").hide();
        $('#doc_Importfile').val("");
        this.fileBase64 = "";
        this.LocalFilePath = response.Message;
        if (response.Status == "Success") {
          $("#btnUpload").show();
        }
        else {
          var ExcelData = response.ExcelData;

          if (ExcelData == null) {

            ngswal("Failed !", response.Message, "");
          }
          $("#tblErrorValidation").show();
          $("#errormessageLabel").show();
          ngswal("Failed !", "Please review the file you uploaded, make any necessary corrections, and reupload it.", "warning");
          this.ExcelErrorValidations(ExcelData);
        }
      }, error => {

        $("#LoadingImage").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
  }

  addUpdateExcel() {
    var fileexcel = {
      fileLocalPath: this.LocalFilePath
    }
    ApiMethod.postMethod(this.modelItem.ImportExcelfileAPI, fileexcel).subscribe(
      response => {
        $("#LoadingImage").hide();
        $('#doc_Importfile').val("");
        this.fileBase64 = "";
        if (response.status == "Success") {
          ngswal("Success !", "File Imported Successfully", "success");
          this.showExcelPopupBody = false;
          $('#doc_file').val("");

        }
        else {
          ngswal("Failed !", "File Imported Failed", "error");

        }


      }, error => {

        $("#LoadingImage").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
  }

  ExcelErrorValidations(ExcelData) {

    $("#tblErrorValidationList tbody").html("");

    var nRowL: "";
    if (ExcelData.length != 0) {
      nRowL = "";
      for (var i = 0; i < ExcelData.length; i++) {
        nRowL += "<tr id='trExcelData_" + (i + 1).toString() + "'>";
        nRowL += "<td>" + (i + 1).toString() + "</td>";
        nRowL += "<td>" + ExcelData[i].Content + "</td>";
        nRowL += "<td>" + ExcelData[i].Status + "</td>";
        nRowL += "<td>" + ExcelData[i].Remarks + "</td>";
        nRowL += "</tr>";
      }

      $("#tblErrorValidationList tbody").append(nRowL);
    }
    this.showExcelValidationPopup = true;
  }

  DownloadSupportFiles() {
    ApiMethod.Downloadfile(this.modelItem.DownloadBudgetsamplefileAPI);
  }

  onFileSelected(event) {


  }

  importExcelPopup() {
    this.showExcelPopupBody = true;
    $("#tblErrorValidation").hide();
    $("#btnUpload").hide();
    $("#errormessageLabel").hide();
  }

  hideExcelpopup() {
    this.showExcelPopupBody = false;
    this.clearBudgetdata();
  }

  hideOnshore() {
    this.showOnshoreModal = false;
  }
  addOnshoreTask() {
    if
      ($('#ddlVendorTask').val() == null) {
      ngswal("Warning !", "Enter Task  !", "warning");
    }
    else if ($('#txtOnshoreTAT').val() == null || $('#txtOnshoreTAT').val() == 0) {
      ngswal("Warning !", "Enter TAT!", "warning");
    }
    else if ($('#ddlAllocationType').val() == null) {
      ngswal("Warning !", "Enter Allocation Type!", "warning");
    }
    else {


      var JournalOnshore = {
        TaskID: $('#ddlVendorTask').val(),
        TAT: $('#txtOnshoreTAT').val(),
        AllocationType: $('#ddlAllocationType').val(),
        Code: $('#txtOnshoreCode').val(),
        OACode: $('#txtOnshoreOACode').val(),
        Id: localStorage.aOnshoreID,
        PublisherId: localStorage.aPubID,
        JournalId: localStorage.aEID,
        LoginID: localStorage.aLoginID
      };

      ApiMethod.postMethod(this.modelItem.JournalOnshoreUpdate, JournalOnshore).subscribe(
        result => {
          this.showNotesModal = false;
          if (result.status == 'Success') {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Updated !",
              text: result.message,
              showConfirmButton: true,
            });
            this.hide();
            this.getSetOptions();
          }
          $("#LoadingImagenotes").hide();
        }, error => {
          ngswal("Failed!", error.Message, "error");
          $("#LoadingImagenotes").hide();
        }
      );

    }
  }

  clearOnshoreSetting() {
    $("#ddlVendorTask").val(0).change();
    $("#txtOnshoreTAT").val("0");
    $("#ddlAllocationType").val("Auto").change();
    $("#txtOnshoreCode").val("");
    $("#txtOnshoreOACode").val("");
  }
  DeleteOnshoreconfirmation() {
    ngswal({
      title: "Are you confirm to delete?",
      text: "Task setting deleted Permanently..!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnDeleteJournalOnshore').trigger("click");
        } else {
          return false;
        }
      });
  };
  deleteJournalOnshore() {
    $("#LoadingImagePopup").show();
    ApiMethod.getMethod(this.modelItem.DeleteJournalOnshoreByID + "/" + localStorage.aOnshoreID).subscribe(
      Response => {
        this.hide();
        this.getJournals();
        if (Response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: Response.message,
            showConfirmButton: true,
          });
        } else {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Failed !",
            text: Response.message,
            showConfirmButton: true,
          });
        }

        $("#LoadingImagePopup").hide();
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }
  showJournalOnshore() {

    this.showOnshoreModal = true;
    this.clearOnshoreSetting();

    $('#container').hide();
    if (localStorage.aOnshoreID != 0) {
      $("#ddlVendorTask").prop('disabled', true);
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.ShowOnshoreSettingByID + '/' + localStorage.aOnshoreID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;

          $("#ddlVendorTask").val(aitems[0].TaskId).change();
          $("#txtOnshoreTAT").val(aitems[0].TAT);
          $("#ddlAllocationType").val(aitems[0].AllocationType).change();
          $("#txtOnshoreCode").val(aitems[0].Code);
          $("#txtOnshoreOACode").val(aitems[0].OACode);
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.NotesModalButton = "Update";
    } else {
      $("#ddlVendorTask").prop('disabled', false);
      this.NotesModalButton = "Save";
      this.title = "Update Setting";
      $(".btnRemovefile").hide();
    }
  }
}


